var _circle, _circle2, _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgPuzzleMobile(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 375,
    viewBox: "0 0 217 375",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 6.25,
    transform: "matrix(0 -1 -1 0 109 367.099)",
    stroke: "#67466C",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 8,
    transform: "matrix(0 -1 -1 0 108 9.099)",
    stroke: "#67466C",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 81.599c59.371 0 107.5 48.129 107.5 107.5 0 59.37-48.129 107.499-107.5 107.499m0-215C49.13 81.599 1 129.729 1 189.1c0 59.37 48.13 107.499 107.5 107.499m0-215v-64m0 279v64.001",
    stroke: "#67466C",
    strokeLinecap: "round",
    strokeDasharray: "12 10"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#puzzle-mobile_svg__filter0_d_116_4928)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 188.599,
    r: 82,
    transform: "rotate(-90 109 188.599)",
    fill: "#DAC5E1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.885 195.269l-.895-.873.895.873zm43.398-44.474l.895.873-.895-.873zm29.629 28.912l-.894-.873.894.873zm-43.399 44.474l.895.873-.895-.873zm-29.27.358l-.873.895.873-.895zm72.311-74.103l-.873.895.873-.895zm-2.476 60.324a1.25 1.25 0 000-2.5v2.5zm-17.367-2.5a1.25 1.25 0 100 2.5v-2.5zm-28.017-37.037a1.25 1.25 0 10-2.492-.203l2.492.203zm-23.915 24.919l43.399-44.474-1.789-1.746-43.399 44.474 1.79 1.746zm71.239-17.308l-6.437 6.596 1.789 1.746 6.437-6.596-1.789-1.746zm-34.603 35.46l-8.796 9.014 1.789 1.746 8.796-9.014-1.789-1.746zm-36.3 9.351c-7.687-7.502-7.838-19.816-.336-27.503l-1.789-1.746c-8.466 8.676-8.296 22.572.38 31.038l1.746-1.789zm-1.745 1.789c8.676 8.466 22.572 8.296 31.038-.38l-1.79-1.746c-7.501 7.688-19.814 7.839-27.502.337l-1.746 1.789zm72.311-74.103c7.688 7.502 7.838 19.815.337 27.503l1.789 1.746c8.466-8.676 8.296-22.572-.38-31.038l-1.746 1.789zm1.746-1.789c-8.676-8.466-22.572-8.296-31.038.38l1.789 1.746c7.502-7.688 19.815-7.839 27.503-.337l1.746-1.789zm9.702 59.968c0 12.035-9.757 21.792-21.792 21.792v2.5c13.416 0 24.292-10.876 24.292-24.292h-2.5zm-21.792 21.792c-12.036 0-21.792-9.757-21.792-21.792h-2.5c0 13.416 10.876 24.292 24.292 24.292v-2.5zm0-43.584c12.035 0 21.792 9.756 21.792 21.792h2.5c0-13.417-10.876-24.292-24.292-24.292v2.5zm-21.792 21.792c0-4.825 1.566-9.28 4.218-12.889l-2.015-1.481a24.194 24.194 0 00-4.703 14.37h2.5zm4.218-12.889c3.969-5.402 10.362-8.903 17.574-8.903v-2.5c-8.041 0-15.169 3.907-19.589 9.922l2.015 1.481zm-.336-1.795c-3.411-2.172-8.359-5.477-12.336-9.599-3.999-4.146-6.813-8.906-6.397-14.004l-2.492-.203c-.503 6.175 2.916 11.616 7.09 15.943 4.197 4.35 9.362 7.787 12.792 9.972l1.343-2.109zm9.284 15.934h17.367v-2.5h-17.367v2.5z",
    fill: "#564793"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "puzzle-mobile_svg__filter0_d_116_4928",
    x: 15,
    y: 106.599,
    width: 188,
    height: 188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0677643 0 0 0 0 0.26974 0 0 0 0 0.306463 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_116_4928"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_116_4928",
    result: "shape"
  })))));
}
export default SvgPuzzleMobile;